/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 6BCq4vMow1yqGKFdcP68Rz

import { createUseGlobalVariants } from "@plasmicapp/react-web";

import { useScreenVariants as useScreenVariantsn2Dxsui6Xhqx } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: n2dxsui6xhqx/globalVariant

export const _useGlobalVariants = createUseGlobalVariants({
  screen: useScreenVariantsn2Dxsui6Xhqx,
});
